module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "IS-EB-5P-5.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('h1', {
    attrs: {
      "id": "toc_marker-5"
    }
  }, [_c('a', {
    attrs: {
      "id": "Anchor-125"
    }
  }, [_vm._v("Introduction: Steve Jobs and the “Vision Thing”")])]), _c('a', {
    attrs: {
      "id": "Anchor-125"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph"
  }), _c('p', [_vm._v("I’m always keeping my eyes open for the next big opportunity, but the way the world is now, it will take enormous resources, both in money and in engineering talent, to make it happen. I don’t know what that next big thing might be, but I have a few ideas.")]), _vm._v(" "), _c('p', [_vm._v("—Steve Jobs, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fortune")]), _vm._v(", January 24, 2000")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }), _c('p', [_vm._v("Since 1976 Steve Jobs spoke his mind, to the delight of his advocates and the dismay of his detractors, in every possible venue: press releases, statements on Apple’s Websites, public appearances to introduce new Apple products, and interviews to the print and electronic media.")]), _vm._v(" "), _c('p', [_vm._v("But no matter what one thinks  of  Jobs, who twice cites “the vision thing” on his résumé, one indisputable  fact stands out: He gave us some of the most memorable quotes about the nature of business in our time.")]), _vm._v(" "), _c('p', [_vm._v("Steve Jobs occupied a unique and enviable position in the business community. He was selected as “CEO of the Decade” by "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fortune")]), _vm._v(" magazine, the “best-performing CEO in the world” by the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Harvard Business Review")]), _vm._v(", and “Person of the Decade” by the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wall Street Journal")]), _vm._v(", among numerous other honors.")]), _vm._v(" "), _c('p', [_vm._v("On August 15, 2011, news broke that the only authorized biography of Steve Jobs, written by Walter Isaacson, had been moved up from March 2012 to November 21, 2011, prompting questions as to why. Big publishers simply don’t move up pub dates four months on a whim. Clearly, a shoe had been dropped.")]), _vm._v(" "), _c('p', [_vm._v("Nine days later, on August 24, the other shoe dropped: Steve Jobs announced he was stepping down as CEO, and asked the Apple board to “execute our succession plan,” which put Timothy Cook at the helm.")]), _vm._v(" "), _c('p', [_vm._v("On October 5, one day after Apple’s new CEO held his first media event to announce the iPhone 4S, Apple’s board stated that Steve Jobs, at age 56, had died. The board released a statement: “Steve’s brilliance, passion and energy were the source of countless innovations that enrich and improve all of our lives. The world is immeasurably better because of Steve.”")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  })])]), _c('a', {
    attrs: {
      "id": "Anchor-125"
    }
  })]), _c('a', {
    attrs: {
      "id": "Anchor-125"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05dcc3be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IS-EB5P-5.vue
// module id = 72
// module chunks = 0